import { getKeys } from './getKeys'

export const emarV2Translations = {
  STOCK_MEDICATION_NAME: 'Stock - {{medicationName}}',
  STOCK: 'Stock',
  EMAR: 'eMAR',
  MANAGE_STOCK: 'Manage Stock',
  MEDICATION_LIST: 'Medication List',
  STOCK_CHECK: 'Stock Check',
  INITIAL_STOCK: 'Initial Stock',
  EDIT_STOCK_CHECK: 'Edit Stock Check',
  DELIVERY: 'Delivery',
  EDIT_DELIVERY: 'Edit Delivery',
  STOCK_MANAGEMENT: 'Stock Management',
  MEDICATION: 'Medication',
  DISPOSAL: 'Disposal',
  EDIT_DISPOSAL: 'Edit Disposal',
  READ_MORE: 'Read more',
  DOWNLOAD_PDF: 'Download PDF',
  VIEW_RECORD: 'View record',
  EDIT_RECORD: 'Edit record',
  EDIT: 'Edit',
  LOW_STOCK_ALERT: 'The stock levels for this medication are low.',
  DATE_RANGE: 'Date Range',
  STOCK_LEVEL_CHART: 'Stock Level Chart',
  STOCK_COUNT_HISTORY: 'Stock Count History',
  TIME_RECORDED: 'Time recorded',
  RECORDED_BY: 'Recorded by',
  ACTION: 'Action',
  EXPECTED_STOCK: 'Expected Stock',
  NOT_SET: 'Not set',
  EXPECTED_STOCK_TOOLTIP:
    "The system's estimated count, updated based on administration, disposals, and deliveries.",
  STOCK_COUNT: 'Stock Count',
  STOCK_COUNT_TOOLTIP:
    'The actual count entered by team members during a stock check.',
  DATE: 'Date',
  STOCK_COUNT_UNIT: 'Stock Count ({{unit}})',
  DESCRIPTION: 'Description',
  DESCRIPTION_REQUIRED: 'Please enter a description',
  DESCRIPTION_MAX_LENGTH: 'Description must not exceed 150 characters',
  ENTER_DESCRIPTION: 'Enter description...',
  ENTER_STOCK_ADJUSTMENT: 'Enter stock adjustment',
  SET_STOCK_COUNT: 'Set stock count',
  DISCREPANCY: 'Discrepancy',
  ADJUSTMENT: 'Adjustment (+/-)',
  NEW_STOCK: 'New Stock',
  TABLETS: 'tablets',
  EXPECTED_STOCK_ACCURATE: 'Expected stock count is accurate',
  ADDITIONAL_DETAILS: 'Additional Details',
  MEDIA: 'Media',
  CLICK_TO_UPLOAD: 'Click to Upload',
  ADJUSTMENT_TOO_HIGH:
    'The value to be deducted is higher than Expected Stock.',
  DISCREPANCY_DETECTED: 'Stock count differs from expected stock count.',
  RESOLVED: 'Resolved',
  DISCREPANCY_RESOLVED: 'Discrepancy has been resolved',
  DISCREPANCY_RESOLVED_SUCCESS: 'Discrepancy resolved successfully',
  DISCREPANCY_RESOLVED_ERROR: 'Failed to resolve discrepancy',
  RESOLVE_DISCREPANCY: 'Resolve discrepancy',
  RESOLVE_DISCREPANCY_REQUIRED:
    'Please select whether to resolve the discrepancy',
  ADD_REASON_TO_RESOLVE_DISCREPANCY:
    'Add a reason to resolve the stock discrepancy.',
  NO_LEAVE_OPEN: 'No (Discrepancy is left open in reports)',
  YES_MARKED_RESOLVED: 'Yes (Marked as resolved in reports)',
  REASON_FOR_DISCREPANCY: 'Reason for discrepancy',
  REASON_FOR_DISCREPANCY_REQUIRED: 'Please enter a reason for the discrepancy',
  ENTER_REASON: 'Enter reason...',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  CURRENT_STOCK_ACCURATE: 'Current stock count is accurate',
  RECEIVED_STOCK: 'Received Stock',
  RECEIVED_BY: 'Received by',
  RECEIVED_BY_REQUIRED: 'Please select who received the added stock',
  RECEIVED_DATE_REQUIRED: 'Please select a date',
  RECEIVED_FROM: 'Received from',
  RECEIVED_FROM_REQUIRED: 'Please enter where the delivery was received from',
  RECEIVED_FROM_TOOLTIP:
    'Enter where you received your medications. For example, enter the name of a pharmacy or a family member.',
  SELECT_DATE: 'Select date',
  SELECT_PERSON: 'Please select',
  TYPE_HERE: 'Type here...',
  WITNESSED_BY: 'Witnessed by',
  STATUS: 'Status',
  MEDICATION_TYPE: 'Medication Type',
  NO_MEDICATIONS_FOUND: 'No medications found',
  AMOUNT: 'Amount',
  DETAILS: 'Details',
  CHANGED: 'changed',
  HAS_STOCK_AMOUNT_CHANGED: 'Has the stock amount changed?',
  YES: 'Yes',
  NO: 'No',
  YES_REMOVED_FROM_STOCK: 'Yes, removed from stock',
  PAUSE_DATE: 'Pause date',
  CONTINUE_DATE: 'Continue date',
  REASON: 'Reason',
  WITNESSED_BY_REQUIRED: 'Please select a witness',
  WITNESS_PIN: 'Witness PIN',
  WITNESS_PIN_REQUIRED: 'Please enter witness PIN',
  INVALID_INPUT: 'Please enter a number greater than 0',
  DISPOSED_STOCK: 'Disposed Stock',
  DISPOSAL_TOO_HIGH:
    'The disposed amount exceeds your expected stock. Please enter a discrepancy reason to adjust your stock before disposal.',
  ACTIONED_BY: 'Actioned by',
  ACTIONED_BY_REQUIRED: 'Please select who actioned the disposal',
  ACTIONED_DATE: 'Actioned date',
  ACTIONED_DATE_REQUIRED: 'Please select a date',
  DISPOSAL_METHOD: 'Disposal method',
  DISPOSAL_METHOD_REQUIRED: 'Please enter the disposal method',
  DISPOSAL_METHOD_TOOLTIP:
    'Enter how the medication was disposed of. For example, enter "Returned to pharmacy", "Destroyed", or "Transferred".',
  ADMINISTERED: 'Administered',
  HOW_MANY_ADMINISTERED: 'How many administered?',
  NO_CHANGE_TO_STOCK: 'No, stock was not updated',
  HOW_MANY_REMOVED: 'How many removed?',
  SCHEDULED_FOR: 'Scheduled for',
  SIGNED_BY: 'Signed by',
  SIGNED_AT: 'Signed at',
  OUTCOME: 'Outcome',
  STOCK_UPDATED: 'Stock updated',
  REMOVED_FROM_STOCK: 'removed from stock',
  LEFT: 'left',
  NOT_APPLICABLE: 'Not applicable',
  PRN: 'PRN',
  COMMENT: 'Comment',
  PREVIOUS_EXPECTED_STOCK: 'Previous Expected Stock',
  ACTIVE: 'Active',
  DISCONTINUED: 'Discontinued',
  SCHEDULED: 'Scheduled',
  NOT_SCHEDULED_PRN: 'Not Scheduled (PRN)',
  WAITING_FOR_DISPOSAL: 'Waiting for disposal',
  NO_STOCK_LEFT: 'No stock left',
  ADD_MEDICATION: 'Add Medication',
  MEDICATION_STOCK: 'Medication Stock',
  STOCK_LEVEL_LOW: 'Stock level low',
  STOCK_LEVEL_OK: 'Stock level ok',
  OUT_OF_STOCK: 'Out of stock',
  UPDATED: 'Updated',
  NO_ACTIVE_MEDICATIONS_TITLE:
    '{{name}} has no active medications at the moment',
  NO_ACTIVE_MEDICATIONS_SUBTITLE: 'Learn more about adding a medication',
  NO_DISCONTINUED_MEDICATIONS_TITLE:
    '{{name}} has no discontinued medications yet',
  NO_DISCONTINUED_MEDICATIONS_SUBTITLE:
    'Only medications discontinued from {{date}} is visible here.',
  HERE: 'here',
  ADD_STOCK_CREATED_SUCCESS: 'Add stock record created successfully',
  ADD_STOCK_UPDATED_SUCCESS: 'Add stock record updated successfully',
  ADD_STOCK_ERROR: 'Failed to save add stock record',
  DISPOSAL_CREATED_SUCCESS: 'Disposal record created successfully',
  DISPOSAL_UPDATED_SUCCESS: 'Disposal record updated successfully',
  DISPOSAL_ERROR: 'Failed to save disposal record',
  STOCK_CHECK_CREATED_SUCCESS: 'Stock check record created successfully',
  STOCK_CHECK_UPDATED_SUCCESS: 'Stock check record updated successfully',
  STOCK_CHECK_ERROR: 'Failed to save stock check record',
  HOUR: 'Hour',
  DOSE: 'Dose',
  CURRENT_STOCK: 'Current Stock',
  START_DATE: 'Start date',
  END_DATE: 'End date',
  LEGEND: 'Legend',
  VERBAL_PROMPT: 'Verbal Prompt',
  ABSENT: 'Absent',
  OTHER: 'Other',
  ALREADY_TAKEN: 'Already Taken',
  NOT_SCHEDULED_OR_NOT_NEEDED: 'Not scheduled or Not needed',
  LEFT_OUT: 'Left Out (only if risk assessed)',
  PAUSED: 'Paused',
  NAUSEA_OR_VOMITING: 'Nausea or Vomiting',
  REFUSED: 'Refused',
  MISSED: 'Missed',
  REFUSED_AND_DESTROYED: 'Refused & Destroyed',
  CD: 'CD',
  ATTACHMENTS: 'Attachments',
  WITNESSES: 'witnesses',
  MEDICINES_ARE_LOW_STOCK: 'medicines are low stock',
  MEDICINES_ARE_OUT_STOCK: 'medicines are out stock',
  OPEN_DISCREPANCIES_LAST_30_DAYS: 'open discrepancies (last 30 days)',
  VIEW_STOCK_LEVELS: 'View Stock Levels',
  VIEW_STOCK_DISCREPANCIES: 'View Stock Discrepancies',
  TIME: 'Time',
  NOT_SIGNED: 'Not signed',
  DUE: 'Due',
  SIGNED: 'Signed',
  NOT_ADMINISTERED: 'Not administered',
  VIEW_ALL: 'View All',
  LOW_STOCK: 'low stock',
  OUT_STOCK: 'out stock',
  AND: 'and',
  ACCURATE_AND_EFFICIENT_EMAR_CHARTS:
    'Accurate and efficient electronic MAR charts',
  ACCOUNTABLE_EMAR_WITH_STOCK_CONTROL:
    'Accountable eMAR, with stock control and automatic alerts.',
  EMPTY_STATE_DESCRIPTION:
    'Safer with every action, audit ready by design, and crystal clear for everyone involved',
  SET_UP_EMAR: 'Set up eMAR',
  ADD_STOCK: 'Add Stock',
  EDIT_ADDED_STOCK: 'Edit Added Stock',
  NOTES: 'Description',
  MEDIA_ATTACHMENTS: 'Attachments',
  PREVIOUS_STOCK_LEVEL: 'Previous Expected Stock',
  QUANTITY_CHANGE: 'Quantity Change',
  RECEIVED_DATE: 'Received Date',
  ACTION_TIME: 'Action Time',
  DISPOSED_BY: 'Disposed By',
  REVISION: 'Revision',
  STOCK_DISCREPANCIES: 'Stock Discrepancies',
  OPEN_DISCREPANCIES: 'Open Discrepancies',
  RESOLVED_DISCREPANCIES: 'Resolved Discrepancies',
  SERVICE_USER: 'Service User',
  ADD_REASON: 'Add reason',
  RESOLVED_AT: 'Resolved At',
  RESOLVED_BY: 'Resolved By',
  DISCREPANCY_REASON: 'Discrepancy Reason',
  MEDICATION_NOT_FOUND: 'Medication not found',
  MEDICATION_DATA_NOT_AVAILABLE:
    'Medication data is not available at this time.'
}

export const emarV2Constants = getKeys(
  emarV2Translations as Record<string, any>
)
